GatorSurvey.app.directive("gsRadioQuestion", ['surveyResponseService', GsRadioQuestion]);
function GsRadioQuestion(surveyResponseService) {
    return {
        restrict: 'AE',
        scope: {
            gsModel: "=ngModel",
            mode: "=?"
        },
        templateUrl: 'Assets/Scripts/App/Directives/Questions/Templates/RadioQuestionLive.html',
        controller: ['$scope', '$q', '$timeout', function ($scope, $q, $timeout) {
          
           
          
            $scope.radioChange = function (offeredAnswer) {
                var id = getUrlParameter("t") !== "1" ? offeredAnswer.id : offeredAnswer.tempId;
                surveyResponseService.updateResponseQuestion($scope.gsModel, id, false);
            };

            $scope.radioOtherText = function (text) {
                if ($scope.isOtherChecked) {
                    surveyResponseService.updateResponseQuestion($scope.gsModel, text, 'text');
                }
            };

            $scope.radioChangeOther = function (answerText) {
                $scope.isOtherChecked = !$scope.isOtherChecked;
                surveyResponseService.updateResponseQuestion($scope.gsModel, null,'isOther');
            };

            $scope.getOfferedAnswerId = function (offeredAnswer) {
                var id = getUrlParameter("t") !== "1" ? offeredAnswer.id : offeredAnswer.tempId;
                return id;
            };

            $scope.getModelId = function () {
                var id = getUrlParameter("t") !== "1" ? $scope.gsModel.id : $scope.gsModel.tempId;
                return id;
            };

          
                surveyResponseService.AddNewQuestion($scope.gsModel,
                    function(response) {
                        if (response.answer.indexOf("IsOther") > -1 && $scope.gsModel.useIfOther) {
                            $scope.isOtherChecked = true;
                            var otherText = response.answer.substring("IsOther:".length, response.answer.length);
                            $scope.gsModel.otherText = otherText == null ? '' : otherText;
                            
                        } else {
                            $scope.gsModel.checked = response.answer;
                        }
                    });
            
        }]
    };
} 